const formatIpRanges = (ranges) => ranges.replace(/\s/g, '').replace(/\r?\n/g, ',').replace(/,$/g, '')

export default formatIpRanges
